
export const Settings = () => {


    return (
        <div>
Settings Page
            //TODO replace with real settings page
        </div>
    )
}